import i18n from '@/api/i18n/i18n';

const actionDict = {
  5: i18n.t('pages.actionDict.rename'),
  6: i18n.t('pages.actionDict.create'),
  7: i18n.t('pages.actionDict.delete'),
  40: i18n.t('pages.actionDict.modify'),
  41: i18n.t('pages.actionDict.renameOldName'),
  42: i18n.t('pages.actionDict.renameNewName'),
  43: i18n.t('pages.actionDict.blocked'),
  48: i18n.t('pages.actionDict.readFile'),
  49: i18n.t('pages.actionDict.writeFile'),
};

export const action = (val) => actionDict[val];
